import { AfterContentInit, Component, ContentChildren, EventEmitter, HostBinding, Input, OnChanges, Output, QueryList, SimpleChanges, ViewEncapsulation } from '@angular/core';
import { StepComponent } from './step/step.component';

@Component({
    selector: 'tt-stepper',
    templateUrl: './stepper.component.html',
    styleUrls: ['./stepper.component.css'],
    encapsulation: ViewEncapsulation.None,
})
export class StepperComponent implements AfterContentInit, OnChanges {
    @ContentChildren(StepComponent)
    public steppers: QueryList<StepComponent> = new QueryList();

    /**
     *
     */
    @Input()
    public ttPageIndex: number | `${number}` = 0;

    @Output()
    public ttPageIndexChange = new EventEmitter<number | `${number}`>();

    public onStepClicked(step: StepComponent, index: number) {
        this.ttPageIndex = index;
        this.ttPageIndexChange.emit(this.ttPageIndex);
        this.toggleSelected(step);
    }

    public previous() {
        this.ttPageIndex = +this.ttPageIndex - 1;
        this.ttPageIndexChange.emit(this.ttPageIndex);

        const step = this.steppers.get(this.ttPageIndex);

        if (step) this.toggleSelected(step);
    }

    public next() {
        this.ttPageIndex = +this.ttPageIndex + 1;
        this.ttPageIndexChange.emit(this.ttPageIndex);

        const step = this.steppers.get(this.ttPageIndex);

        if (step) this.toggleSelected(step);
    }

    private toggleSelected(step: StepComponent) {
        this.steppers.forEach((step) => this.removeSelectedStyle(step));
        this.addSelectedStyle(step);
    }

    @HostBinding('style.--tt-step-index')
    get cssStepIndex() {
        return this.ttPageIndex;
    }

    @HostBinding('style.--tt-step-count')
    get cssStepCount() {
        return this.steppers?.length ?? 0;
    }

    @HostBinding('class.tt-stepper--compact')
    get isCompact() {
        return (this.steppers?.length ?? 0) > 5;
    }

    ngAfterContentInit(): void {
        this.assureOneSelected(this.steppers);

        this.steppers.changes.subscribe({ next: (steppers: QueryList<StepComponent>) => this.assureOneSelected(steppers) });
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['ttPageIndex']) {
            if (!isNaN(+changes['ttPageIndex'].currentValue)) {
                this.ttPageIndex = +changes['ttPageIndex'].currentValue;
            }
        }
    }

    private assureOneSelected(steppers: QueryList<StepComponent>) {
        if (!this.hasStepSelected(steppers) && !!steppers.first) {
            this.addSelectedStyle(steppers.first);
        }
    }

    private hasStepSelected(steppers: QueryList<StepComponent>) {
        return steppers.filter((step) => this.hasSelectedStyle(step)).length > 0;
    }

    private removeSelectedStyle(step: StepComponent) {
        step.elementRef.nativeElement.classList.remove('tt-step--selected');
    }

    private addSelectedStyle(step: StepComponent) {
        step.elementRef.nativeElement.classList.add('tt-step--selected');
    }

    private hasSelectedStyle(step: StepComponent) {
        return step.elementRef.nativeElement.classList.contains('tt-step--selected');
    }

    get stepCount() {
        return this.steppers?.length ?? 0;
    }
}
